import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import { FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentEventQuery } from '../../../event/hooks/useCurrentEventQuery';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { useUpdateUserTinderJoinedMutation } from '../../hooks/useUpdateUserTinderJoinedMutation';
import { JoinTinderDialog } from './components/JoinTinderDialog';
import { LeaveTinderDialog } from './components/LeaveTinderDialog';
import { TinderSwipe } from './components/TinderSwipe/TinderSwipe';

export const Tinders: FunctionComponent = () => {
  const { data: currentUserData } = useCurrentUserQuery();
  const { data: currentEventQueryData } = useCurrentEventQuery();
  const { updateUserTinderJoined } = useUpdateUserTinderJoinedMutation();
  const [isJoinDialogOpen, setIsJoinDialogOpen] = useState(false);
  const [isLeaveDialogOpen, setIsLeaveDialogOpen] = useState(false);
  const navigate = useNavigate();

  if (!currentEventQueryData?.currentEvent?.isValidated) {
    return null;
  }

  const onToggleTinderJoined = (hasJoinedTinder: boolean) => {
    const eventId = currentEventQueryData.currentEvent?.id;

    if (!eventId) {
      return;
    }

    updateUserTinderJoined({
      eventId,
      hasJoinedTinder,
    });
  };

  const onConfirmJoin = () => {
    onToggleTinderJoined(true);
    setIsJoinDialogOpen(false);
  };

  const onConfirmLeave = () => {
    onToggleTinderJoined(false);
    setIsLeaveDialogOpen(false);
  };

  return (
    <Layout title="Meetics" activeTab="tinder" noPadding>
      {!currentEventQueryData.currentEvent.isTinderEnabled ? (
        <>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="h6">
                {
                  "Le mode Meetic n'est pas activé pour cet événement. Mais vous pouvez déjà vous y préparer !"
                }
              </Typography>

              <Typography>
                Pour participer au Meetic, vous devez ajouter des images à votre
                profil.
              </Typography>
            </CardContent>
            <CardActions>
              <Button variant="outlined" onClick={() => navigate('/images')}>
                Ajouter des images
              </Button>
            </CardActions>
          </Card>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="h6">{'Inscription'}</Typography>
              <Typography>
                {currentEventQueryData.currentEvent.hasJoinedTinder
                  ? 'Vous êtes inscrit au Meetic pour cet événement. Vous pouvez vous désinscrire à tout moment en cliquant sur le bouton ci-dessous.'
                  : 'Vous devez vous inscrire en cliquant sur le bouton ci-dessous. Vous pouvez vous désinscrire à tout moment'}
              </Typography>
            </CardContent>
            <CardActions>
              {currentEventQueryData.currentEvent.hasJoinedTinder ? (
                <Button
                  variant="contained"
                  onClick={() => setIsLeaveDialogOpen(true)}
                  color="error"
                >
                  {'Me désinscrire de Meetic'}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={() => setIsJoinDialogOpen(true)}
                >
                  {"M'inscrire au Meetic"}
                </Button>
              )}
            </CardActions>
          </Card>
        </>
      ) : currentUserData?.currentUser?.images?.length === 0 ? (
        <Card sx={{ mt: 2 }}>
          <CardContent>
            <Typography>
              Vous devez ajouter des images avant de pouvoir swiper.
            </Typography>
          </CardContent>
          <CardActions>
            <Button variant="contained" onClick={() => navigate('/images')}>
              Ajouter des images
            </Button>
          </CardActions>
        </Card>
      ) : currentEventQueryData.currentEvent.hasJoinedTinder ? (
        <>
          <Box sx={{ px: 0 }}>
            {currentEventQueryData?.currentEvent ? (
              <TinderSwipe eventId={currentEventQueryData.currentEvent.id} />
            ) : null}
          </Box>
          <Box
            sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 2 }}
          >
            <Button
              variant="contained"
              onClick={() => navigate('/tinder/stats')}
            >
              Voir les meetics
            </Button>
            <Button
              variant="contained"
              onClick={() => setIsLeaveDialogOpen(true)}
              color="error"
            >
              {'Me désinscrire de Meetic'}
            </Button>
          </Box>
        </>
      ) : (
        <Card sx={{ mt: 2 }}>
          <CardContent>
            <Typography>
              Pour participer au Meetic, vous devez vous inscrire en cliquant
              sur le bouton ci-dessous. Vous pouvez vous désinscrire à tout
              moment
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              variant="contained"
              onClick={() => setIsJoinDialogOpen(true)}
            >
              {"M'inscrire au Meetic"}
            </Button>
          </CardActions>
        </Card>
      )}
      <JoinTinderDialog
        open={isJoinDialogOpen}
        onCancel={() => setIsJoinDialogOpen(false)}
        onJoin={onConfirmJoin}
      />
      <LeaveTinderDialog
        open={isLeaveDialogOpen}
        onCancel={() => setIsLeaveDialogOpen(false)}
        onLeave={onConfirmLeave}
      />
    </Layout>
  );
};
